export const DEFAULT_MT_CITY_ID = 1;
export const DEFAULT_DP_CITY_ID = 2;
export const PlatformEnum = {
    mtApp: 1,
    // 美团app
    mtAppWebView: 1,
    dpApp: 2,
    // 点评App
    mtDpAppWebview: 2,
    mtMinaWebview: 3,
    // 美团微信小程序
    mtHotelMinaWebview: 4,
    // 美团酒店微信小程序
    mtDpMinaWebview: 5 // 点评微信小程序
};
export const MeituanPlatform = ['mtApp', 'mtMinaWebview', 'mtHotelMinaWebview'];
// 点评app、点评小程序、点评webview
export const DianpingPlatform = ['dpApp', 'mtDpMinaWebview', 'mtDpAppWebview'];
export const AI_BUTTON_GIF_URLS = ['https://img.meituan.net/makerjiulv/475648869348d469435b7a16c19f196d288713.gif', 'https://img.meituan.net/makerjiulv/55bba97cbaab274cf67d95512e9230f8288694.gif'];
export const LX_CONFIG = {
    CITY_MV_BID: 'b_daodian_lowcode_m9yxifto_mv',
    // 城市展示
    CITY_MC_BID: 'b_daodian_lowcode_0fuxcet9_mc',
    // 城市切换
    AI_CONTENT_MV_BID: 'b_daodian_lowcode_mkci917l_mv',
    // ai推荐内容展示
    AI_CONTENT_MC_BID: 'b_daodian_lowcode_0wwdl0ku_mc',
    // ai推荐地标被点击
    AI_BUTTON_MV_BID: 'b_daodian_lowcode_655y37wb_mv',
    // ai开关展示
    AI_BUTTON_MC_BID: 'b_daodian_lowcode_cptxcxcn_mc',
    // ai开关点击
    HOTSPOT_MV_BID: 'b_daodian_lowcode_rshz1cmq_mv',
    // 地标标签展示
    HOTSPOT_MC_BID: 'b_daodian_lowcode_dkkijxas_mc',
    // 地标标签点击
    QUERY_MC_BID: 'b_daodian_lowcode_la77k2ww_mc' // 文字搜索
};
